import { Component, OnInit } from '@angular/core';
import { LanguageConst } from '@core-constants/language.const';
import { LocalStorageService } from '@shared-services/local-storage.service';
import { TranslateService } from '@shared-services/translate.service';
import { SettingsManager } from '@core-managers/settings.manager';
import { Router } from '@angular/router';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent implements OnInit
{
  public pageTitle: string = "Akky | Estamos mejorando nuestros servicios";

  public day: string = "sábado";
  public month: string = "febrero";
  public hour: string = "11:00 p.m";
  public number: string = "21";

  public langCode: string = LanguageConst.ES;
  public backgroundImage = "/maintenance/back.svg";

  constructor(protected translateService: TranslateService,
    public settingsManager: SettingsManager,
    private router: Router,
    protected localStorageService: LocalStorageService) { }

  public ngOnInit(): void
  {
    this.setLanguage();
    this.validatedInMaintenance();
  }

  public ngOnLanguageChange(code: string = this.langCode): void
  {
    const _code = code.toLowerCase();
    this.langCode = _code;
    this.setLanguage();
  }

  private setLanguage(): void
  {
    this.translateService.use(this.langCode);
  }

  public validatedInMaintenance(): void
  {
    if (!this.settingsManager.isMaintenance)
    {
      this.router.navigate(['/']);
    }
  }
}


